import { useState } from "react";
import { Users, Trophy, Heart, User } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const categories = [
  { 
    id: "juniores", 
    label: "Juniores", 
    age: "U19",
    image: "https://customer-assets.emergentagent.com/job_fef51c73-3fe9-4a0a-b70a-2a7119fa5032/artifacts/1hg0rtpn_c2455e37-1f0f-45c0-8b8a-b7b05a4b415b.jpeg",
    staff: [
      { role: "Allenatore", name: "Romeo Costantino" },
      { role: "Vice-allenatore", name: "Daniele Licata" },
      { role: "Preparatore portieri", name: "Flavio Bassani" },
      { role: "Dirigente responsabile", name: "Mario Nota" },
      { role: "Dirigenti accompagnatori", name: "Loris Pareschi, Piero Capussotto" },
    ],
    portieri: ["Andrea Amodio", "Fabrizio Guagliotta"],
    difensori: ["Alessandro Marinella", "Mattia Negro Fer", "Sebastiano Zucco", "Pietro Farisco", "Alessandro Giammarco", "Mattia Empoli"],
    centrocampisti: ["Niccolò Giardino", "Andrea Stefanelli", "Simone Vaschetto", "Emanuele Gradia"],
    attaccanti: ["Cristian D'Abbene", "Reda Touti", "Luca Gambino", "Riccardo Pettinari", "Marco Croce", "Niccolò De Luca"],
  },
  { 
    id: "under17", 
    label: "Under 17", 
    age: "U17",
    image: "https://customer-assets.emergentagent.com/job_fef51c73-3fe9-4a0a-b70a-2a7119fa5032/artifacts/k9bgfqch_Volpiano_Under17.jpeg",
    staff: [
      { role: "Allenatore", name: "Alessandro Francesco Malagrinò" },
      { role: "Vice-allenatore", name: "Antonio Loria" },
      { role: "Preparatore portieri", name: "Giancarlo Barghini" },
      { role: "Dirigente responsabile", name: "Massimo Azzalin" },
      { role: "Dirigenti accompagnatori", name: "Fabrizio Di Giorgio, Emilio De Cicco" },
      { role: "Massoterapeuta", name: "Elisabetta Rodella" },
    ],
    portieri: ["Lorenzo Schierano", "Ivan Guarnieri"],
    difensori: ["Federico Bazzini", "Fabio Kalala", "Stefano Laguardia", "Christian Mininni", "Riccardo Sacco", "Marco Bertot"],
    centrocampisti: ["Alessandro Roncarolo", "Leonardo Provenzano", "Alex Ingbinobaro", "Manuel Casazza", "Gabriele Zamuner", "Vittorio Pani", "Francesco Pomero"],
    attaccanti: ["Emiliano Zamboni", "Matteo Bardus", "Tony Lisneanu", "Mattia Laurenti", "Gabriele Barrera"],
  },
  { 
    id: "under16", 
    label: "Under 16", 
    age: "U16",
    image: "https://customer-assets.emergentagent.com/job_fef51c73-3fe9-4a0a-b70a-2a7119fa5032/artifacts/nmi42510_Volpiano_Under16.jpeg",
    staff: [
      { role: "Allenatore", name: "Raffaele Senatore" },
      { role: "Vice-allenatore", name: "Simone Schiraldi" },
      { role: "Preparatore atletico", name: "Valentino Amateis" },
      { role: "Preparatore portieri", name: "Giancarlo Barghini" },
      { role: "Dirigente responsabile", name: "Michele Saviano" },
      { role: "Dirigenti accompagnatori", name: "Andrea Ertola, Santino Greco" },
    ],
    portieri: ["Arklejo Halili", "Francesco Internò"],
    difensori: ["Paolo Barberis", "David Doumbia", "Alberto Ertola", "Alessandro Franco", "Alberto Mascaro", "Cristian Di Lorenzo"],
    centrocampisti: ["Eduardo Di Corleto", "Emanuele Greco", "Anass Kane", "Alessandro Lupo", "Tommaso Marino", "Mattia Silombra", "Riccardo Vespa"],
    attaccanti: ["Samuele Barbetta", "Tito Camoriano", "Demetrio D'Ario", "Adamo Gramoutè", "Liam Perrier"],
  },
  { 
    id: "under15", 
    label: "Under 15", 
    age: "U15",
    image: "https://customer-assets.emergentagent.com/job_fef51c73-3fe9-4a0a-b70a-2a7119fa5032/artifacts/mvtp5fwv_Volpiano_Under15.jpeg",
    staff: [
      { role: "Allenatore", name: "Andrea Mandes" },
      { role: "Vice-allenatore", name: "Fabrizio Tosatto" },
      { role: "Preparatore atletico", name: "Denis Allegretti" },
      { role: "Preparatore portieri", name: "Giancarlo Barghini" },
      { role: "Dirigenti accompagnatori", name: "Mariangela Criscuolo, Rosario Selvaggio" },
    ],
    portieri: ["Lorenzo Campanale", "Niccolò Giovetti"],
    difensori: ["Alessandro Manara", "Zeno Corrieri", "Samuele Sandretto", "Jacopo Serra", "Tommaso Bosco", "Alessandro La Tella", "Mattia Pace", "Matteo Bernardi"],
    centrocampisti: ["Riccardo Repole", "Andrea Salsa", "Marco Sandrone", "Umberto Croveri", "Nicolò Benedetto"],
    attaccanti: ["Gabriele D'Aprile", "Davide Vasi", "Alexis Turcotti", "Diego Cerbone"],
  },
  { 
    id: "under14", 
    label: "Under 14", 
    age: "U14",
    image: "https://customer-assets.emergentagent.com/job_fef51c73-3fe9-4a0a-b70a-2a7119fa5032/artifacts/1r9p4v7n_Volpiano_Under14.jpeg",
    staff: [
      { role: "Allenatore", name: "Andrea Mirasola" },
      { role: "Vice-allenatore", name: "Elia Salaro" },
      { role: "Preparatore atletico", name: "Denis Allegretti" },
      { role: "Preparatore portieri", name: "Giancarlo Barghini" },
      { role: "Dirigente responsabile", name: "Emilio De Cicco" },
      { role: "Dirigenti accompagnatori", name: "Antonio Calabrese, Danilo Gremignani, Stefano Berton" },
    ],
    portieri: ["Thomas Sarritzu", "Andrea Pontello", "Lorenzo Longhin"],
    difensori: ["Riccardo Gremignani", "Andrea Calabrese", "Alexandru Stefanovici", "Francesco Cartisano", "Christian De Palma", "Nicolò Negro Frer", "Andrea Minuto"],
    centrocampisti: ["Filippo Picco", "Lorenzo Cocciolo", "Samuel Binatti", "Nicolò Binatti", "Loris Mariello", "Iacopo Berton"],
    attaccanti: ["Gabriele Esposito", "Jacopo Sacco", "Edoardo Tarricone", "Maguette Ndiaye", "Alessandro Tarsitano"],
  },
];

const GiovaniliPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("juniores");
  const currentCategory = categories.find((c) => c.id === selectedCategory);

  return (
    <div data-testid="giovanili-page">
      <Navbar />

      {/* Hero */}
      <section className="pt-24 lg:pt-32 pb-12 bg-[#0047AB] noise-overlay">
        <div className="max-w-7xl mx-auto px-4 text-center text-white">
          <h1 className="text-4xl lg:text-5xl font-black uppercase mb-4 animate-fade-in-up">
            Settore Giovanile
          </h1>
          <p className="text-blue-200 max-w-xl mx-auto">
            Formiamo i campioni di domani con passione e dedizione
          </p>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-12 bg-white" data-testid="youth-info-section">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div className="p-6">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="w-8 h-8 text-[#0047AB]" />
              </div>
              <h3 className="font-bold text-lg mb-2">5 Categorie</h3>
              <p className="text-slate-600 text-sm">
                Dalla Juniores all'Under 14, un percorso di crescita completo
              </p>
            </div>
            <div className="p-6">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <Trophy className="w-8 h-8 text-[#0047AB]" />
              </div>
              <h3 className="font-bold text-lg mb-2">Staff Qualificato</h3>
              <p className="text-slate-600 text-sm">
                Istruttori e preparatori dedicati per ogni categoria
              </p>
            </div>
            <div className="p-6">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="w-8 h-8 text-[#0047AB]" />
              </div>
              <h3 className="font-bold text-lg mb-2">Valori</h3>
              <p className="text-slate-600 text-sm">
                Crescita sportiva e personale per ogni giovane atleta
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Category Tabs */}
      <section className="section-padding bg-slate-50" data-testid="category-section">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl lg:text-3xl font-bold text-slate-900 mb-8 text-center">
            Le Nostre Squadre
          </h2>

          {/* Tabs */}
          <div
            className="flex flex-wrap justify-center gap-3 mb-8"
            data-testid="category-tabs"
          >
            {categories.map((cat) => (
              <button
                key={cat.id}
                data-testid={`category-tab-${cat.id}`}
                onClick={() => setSelectedCategory(cat.id)}
                className={`px-5 py-2.5 rounded-full font-semibold transition-all text-sm md:text-base ${
                  selectedCategory === cat.id 
                    ? "bg-[#0047AB] text-white shadow-lg" 
                    : "bg-white text-slate-700 hover:bg-slate-100"
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          {/* Category Content */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg">
            {/* Category Header */}
            <div className="bg-gradient-to-r from-[#0047AB] to-[#003380] p-6 text-white">
              <div className="flex items-center justify-center gap-4">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center">
                  <span className="font-bold text-2xl">{currentCategory?.age}</span>
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-bold">{currentCategory?.label}</h3>
                  <p className="text-blue-200 text-sm">G.S.D. Volpiano Pianese</p>
                </div>
              </div>
            </div>

            {/* Team Photo */}
            <div className="bg-slate-100">
              {currentCategory?.image ? (
                <img
                  src={currentCategory.image}
                  alt={`Squadra ${currentCategory?.label}`}
                  className="w-full h-auto object-contain"
                  data-testid={`team-photo-${selectedCategory}`}
                />
              ) : (
                <div className="flex items-center justify-center py-24 bg-slate-200">
                  <div className="text-center">
                    <User className="w-16 h-16 text-slate-400 mx-auto mb-4" />
                    <p className="text-slate-500 font-medium">Foto squadra in arrivo</p>
                  </div>
                </div>
              )}
            </div>

            {/* Staff */}
            <div className="p-6 border-b border-slate-100">
              <h4 className="text-lg font-bold text-[#0047AB] mb-4 flex items-center gap-2">
                <span className="w-6 h-1 bg-[#0047AB] rounded-full" />
                Staff Tecnico
              </h4>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
                {currentCategory?.staff.map((member, idx) => (
                  <div key={idx} className="bg-slate-50 rounded-lg p-3">
                    <p className="text-xs text-[#0047AB] font-medium uppercase">{member.role}</p>
                    <p className="font-semibold text-slate-900">{member.name}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Players by Role */}
            <div className="p-6 space-y-6">
              {/* Portieri */}
              {currentCategory?.portieri && currentCategory.portieri.length > 0 && (
                <div>
                  <h4 className="text-md font-bold text-slate-700 mb-3 flex items-center gap-2">
                    <span className="w-4 h-1 bg-yellow-500 rounded-full" />
                    Portieri
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {currentCategory.portieri.map((name, idx) => (
                      <span key={idx} className="bg-yellow-50 text-yellow-800 px-3 py-1.5 rounded-full text-sm font-medium">
                        {name}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Difensori */}
              {currentCategory?.difensori && currentCategory.difensori.length > 0 && (
                <div>
                  <h4 className="text-md font-bold text-slate-700 mb-3 flex items-center gap-2">
                    <span className="w-4 h-1 bg-blue-500 rounded-full" />
                    Difensori
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {currentCategory.difensori.map((name, idx) => (
                      <span key={idx} className="bg-blue-50 text-blue-800 px-3 py-1.5 rounded-full text-sm font-medium">
                        {name}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Centrocampisti */}
              {currentCategory?.centrocampisti && currentCategory.centrocampisti.length > 0 && (
                <div>
                  <h4 className="text-md font-bold text-slate-700 mb-3 flex items-center gap-2">
                    <span className="w-4 h-1 bg-green-500 rounded-full" />
                    Centrocampisti
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {currentCategory.centrocampisti.map((name, idx) => (
                      <span key={idx} className="bg-green-50 text-green-800 px-3 py-1.5 rounded-full text-sm font-medium">
                        {name}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Attaccanti */}
              {currentCategory?.attaccanti && currentCategory.attaccanti.length > 0 && (
                <div>
                  <h4 className="text-md font-bold text-slate-700 mb-3 flex items-center gap-2">
                    <span className="w-4 h-1 bg-red-500 rounded-full" />
                    Attaccanti
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {currentCategory.attaccanti.map((name, idx) => (
                      <span key={idx} className="bg-red-50 text-red-800 px-3 py-1.5 rounded-full text-sm font-medium">
                        {name}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GiovaniliPage;
